export const apiListAdImageWrapper = (res) => {
    if (res?.resultItems && Array.isArray(res.resultItems)) {
        fixAdImages(res.resultItems);
    }
    return res;
};

const fixAdImages = (images) => {
    images
        .filter((item) => item.imageurl !== undefined)
        .forEach((item) => {
            if (!item.imageurl.includes('http')) {
                item.imageurl = prependImageUrl(item.imageurl);
            }
        });
};

export const apiRecommendedAdImageWrapper = (res) => {
    if (res?.items && Array.isArray(res.items)) {
        fixRecommendationImages(res.items);
    } else {
        try {
            const obj = JSON.parse(res);

            fixRecommendationImages(obj.items);

            res = JSON.stringify(obj);
        } catch (error) {
            console.log(`apiRecommendedAdImageWrapper failed with ${error}`);
        }
    }

    return res;
};

const fixRecommendationImages = (images) => {
    images
        .filter((item) => item.image !== undefined && item.image.isAbsolute === false)
        .forEach((item) => {
            item.image.url = prependImageUrl(item.image.url);
        });
};

// TODO: https://nmp-jira.atlassian.net/browse/REIS-7690
export const prependImageUrl = (imageUrl) => `https://images.finncdn.no/dynamic/default/${imageUrl}`;
